import {Resource} from '@lib/store';
import {constructFilter} from './constructFilter';
import {TFunction} from 'i18next';

export const constructResourceTypeFilter = (t: TFunction) =>
  constructFilter<Resource, {id: Resource['type']; label: string}>({
    sectionId: SECTION_ID_RESOURCE_TYPE_FILTER,
    sectionTitle: t('screen:ResourceTypeFilterSectionTitle'),
    type: 'or',
    data: [
      {id: 'room', label: t('hereAndNow:ResourceFilterRooms')},
      {id: 'area', label: t('hereAndNow:ResourceFilterAreas')},
      {id: 'facility', label: t('hereAndNow:ResourceFilterFacilities')},
    ],
    defaultFilterOptions: [],
    predicate: (filter, entity: Resource) => entity.type === filter.id,
  });

export const SECTION_ID_RESOURCE_TYPE_FILTER = 'SECTION_ID_RESOURCE_TYPE';
